







import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class AgregarButton extends Vue {
  handleClick() {
    this.$emit('click');
  }
}
